module.exports = __webpack_public_path__ + "img/sFwdA.4c9b916b.svg";